export default __webpack_public_path__ + "images/settings-active.svg";